import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";

export const MaxOffersDialog = ({ 
    visible, 
    onHide, 
    onDiscoverOffers
}) => {
    const { t } = useTranslation();

    const handleCancel = () => {
        if (onHide) onHide();
    };

    const handleDiscoverOffers = () => {
        if (onDiscoverOffers) onDiscoverOffers();
    };

    return (
        <Dialog 
            header={t('general.warning')} 
            visible={visible} 
            style={{ width: '30vw' }} 
            onHide={handleCancel}
        >
            <p>{t('entreprise.max_offers_reached_message')}</p>
            <p>{t('entreprise.max_offers_solution')}</p>

            <div className='p-d-flex p-jc-center p-mt-1'>
                <Button 
                    label={t('entreprise.discover_our_offer')} 
                    className="p-mt-2 fcp-button-popup-first-connection" 
                    onClick={handleDiscoverOffers} 
                />
            </div>
        </Dialog>
    );
};